import { render, staticRenderFns } from "./FranchiseDetail.vue?vue&type=template&id=756166a5&scoped=true"
import script from "./FranchiseDetail.vue?vue&type=script&lang=js"
export * from "./FranchiseDetail.vue?vue&type=script&lang=js"
import style0 from "./FranchiseDetail.vue?vue&type=style&index=0&id=756166a5&prod&scoped=true&lang=css"
import style1 from "./FranchiseDetail.vue?vue&type=style&index=1&id=756166a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756166a5",
  null
  
)

export default component.exports